import { FieldControl } from '@signature-it/ngx-generic/enums';
import {FormField} from "./field";

export class FileUploadField extends FormField {

    static ON_COMPLETE_ITEM_EVENT = 'onCompleteItem';
    static ON_BEFORE_UPLOAD_ITEM_EVENT = 'onBeforeUploadItem';
    static ON_AFTER_ADDING_FILE_EVENT = 'onAfterAddingFile';
    static ON_CANCEL_ITEM_EVENT = 'onCancelItem';
    static ON_CLEAR_QUEUE_EVENT = 'onClearQueue';

    controlType = FieldControl.FILE_UPLOAD;
    allowedMimeType: string;
    queueLimit: number = 1;
    showGridPreview: boolean = false;
    immediateUpload: boolean = true;
    extendedControl: boolean = false;
    disableCache: boolean = false;
    saveToScreenAssetLibrary: boolean = false;
    constructor(options: {} = {}) {
        super(options);
        let data;
        try {
            data = JSON.parse(options['additionalInfo']);
            this.allowedMimeType = data['allowedMimeType'];
            this.queueLimit = data['queueLimit'];
            this.showGridPreview = data['showGridPreview'];
            this.immediateUpload = data['immediateUpload'] === false ? false : true;
            this.extendedControl = data['extendedControl']? true : false;
            this.saveToScreenAssetLibrary = data['saveToScreenAssetLibrary'] || false;
        } catch (e) {
            data = options['additionalInfo'] ? options['additionalInfo'].split('|') : [];
            this.allowedMimeType = data[0];
            this.queueLimit = data[1];
            this.showGridPreview = data[2] == 'true' ? true : false;
            this.disableCache = data[3] == 'true' ? true : false;
            this.saveToScreenAssetLibrary = data[4] == 'true' ? true : false;
            this.extendedControl = data[5] ? true : false;
        }

    }
}
